import { Popup, Button, Title, Body } from './ui';
import './ConsentScreen.css';

const PRIVACY_POLICY_URL = 'https://sliceof.games/nonogramdailyprivacypolicy';

interface ConsentScreenProps {
  onAccept: () => void;
  onDecline: () => void;
}

export function ConsentScreen({ onAccept, onDecline }: ConsentScreenProps) {
  return (
    <Popup aria-label="Help improve the game?" maxWidth={360}>
      <div className="consent-inner">
        <Title className="consent-title">Help improve the game?</Title>
        <Body className="consent-body">
          Help us make better puzzles! We only collect basic gameplay stats — like which levels you finish and how long they take. Nothing personal, just puzzle data.
        </Body>
        <Button variant="primary" size="wide" onClick={onAccept}>Yes, sure!</Button>
        <Button variant="ghost" size="wide-sm" onClick={onDecline}>No thanks</Button>
        <a
          className="consent-privacy"
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </Popup>
  );
}
